import React, { useState, useEffect, useContext } from 'react';
import { CategoryRevenueBenchmarkContext } from '.';
import { getBenchmarkRevenue } from 'utils/apiRequests';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import {
	defaultColDefination,
	formatPercentageToSingleDecimal,
	initialGridData,
	renderTableForRevenue,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { allOption } from 'CategoryManagement/utils';
import { formatNumber } from 'utils/number';

const benchmarkTextAboveRevenue = `are beyond benchmark`;
const benchmarkTextWithinRevenue = `are within benchmark`;

const CategoryRevenueBenchmarkProvider = ({ children }) => {
	const { isFetching, currentSelectCategory } = useContext(
		CategoryManagementContext
	);
	const [revenueData, setRevenueData] = useState({
		isFetching: false,
		data: {},
		analysisAboveRevenue: `- ${benchmarkTextAboveRevenue}`,
		analysisWithinRevenue: `- ${benchmarkTextWithinRevenue}`,
		gridData: initialGridData,
		errors: null,
	});

	const fetchData = async value => {
		try {
			setRevenueData({ ...revenueData, isFetching: true });
			const payLoad = {
				categoryName: value,
				flag: 1,
			};
			getBenchmarkRevenue(payLoad)
				.then(response => {
					let analysisStringAboveRevenue,
						analysisStringWithinRevenue,
						rowResult = [],
						colResult = [];
					const categoryLevel =
						value === allOption.id ? 0 : value.split('/').length - 2;
					const dataToMap = renderTableForRevenue(categoryLevel);
					if (response.succeeded) {
						if (!!Object.keys(response.data).length) {
							if (response.data.min !== null) {
								analysisStringWithinRevenue = `${formatNumber(
									response.data.mincount
								)} L${categoryLevel + 1}'s ${benchmarkTextWithinRevenue}`;
							} else {
								analysisStringWithinRevenue = `0 L${categoryLevel +
									1}'s ${benchmarkTextWithinRevenue}`;
							}
							if (response.data.max !== null) {
								analysisStringAboveRevenue = `${formatNumber(
									response.data.maxcount
								)} L${categoryLevel + 1}'s ${benchmarkTextAboveRevenue}`;
							} else {
								analysisStringAboveRevenue = `0 L${categoryLevel +
									1}'s ${benchmarkTextAboveRevenue}`;
							}

							if (response.data.excelGenerateDTO !== null) {
								if (response.data.excelGenerateDTO[dataToMap.key] !== null) {
									rowResult = response.data.excelGenerateDTO[dataToMap.key].map(
										x => {
											return {
												...x,
												client: formatPercentageToSingleDecimal(x.client),
												median: formatPercentageToSingleDecimal(x.median),
												min: formatPercentageToSingleDecimal(x.min),
												max: formatPercentageToSingleDecimal(x.max),
											};
										}
									);
									colResult = dataToMap.columnDefs;
								}
							}
							setRevenueData(prevState => ({
								...prevState,
								isFetching: false,
								data: response.data,
								analysisAboveRevenue: `${analysisStringAboveRevenue}`,
								analysisWithinRevenue: `${analysisStringWithinRevenue}`,
								gridData: {
									...prevState.gridData,
									rowData: rowResult,
									columnDefs: colResult,
									defaultColDef: defaultColDefination,
								},
								errors: response.errors,
							}));
						}
					} else {
						setRevenueData(prevState => ({
							...prevState,
							isFetching: false,
							data: response.data === null ? {} : response.data,
							errors: response.errors,
						}));
					}
				})
				.catch(() =>
					setRevenueData(prevState => ({
						...prevState,
						isFetching: false,
						data: [],
						errors: [],
					}))
				);
		} catch (error) {
			setRevenueData(prevState => ({
				...prevState,
				isFetching: false,
				data: null,
				errors: error,
			}));
		}
	};

	useEffect(
		() => {
			if (!isFetching) {
				if (!revenueData.isFetching) {
					fetchData(currentSelectCategory.categoryName);
				}
			}
		}, // eslint-disable-next-line
		[isFetching, currentSelectCategory.categoryName]
	);

	return (
		<CategoryRevenueBenchmarkContext.Provider
			value={{
				...revenueData,
				fetchData,
			}}
		>
			{children}
		</CategoryRevenueBenchmarkContext.Provider>
	);
};

export { CategoryRevenueBenchmarkProvider, CategoryRevenueBenchmarkContext };
